import React from "react";
import MobilePage from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import { usePictureSets } from "../../../hooks/usePictureSets";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { Link } from "react-router-dom";
import AppBar from "../../Components/AppBar";
import {
  HTMLCarousel,
  HTMLCarouselItem,
} from "../../../Components/HTMLCarousel";
import SubjectSelector from "../../Components/SubjectSelector";
import { webshopUserImageUrlCreator } from "../../../../lib/userImageUrlCreators";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  list: {
    width: "100%",
    overflow: "auto",
    alignItems: "center",
    listStyle: "none",
    margin: 0,
    padding: 0,
    flexGrow: 1,
    display: "flex",
  },
  listItem: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    minWidth: "40vw",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
  },
  newSetText: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    display: "inline-block",
    padding: "3px 10px 3px 10px",
    marginLeft: "-40px",
    marginBottom: theme.spacing(2),
  },
}));

export default () => {
  const { isLoaded, currentPictureSet } = usePictureSets();
  const classes = useStyles();
  console.log("Found picture set ", currentPictureSet, isLoaded);

  if (!isLoaded) {
    return (
      <div>
        <Trans>Loading..</Trans>
      </div>
    );
  }

  return (
    <MobilePage fullHeight>
      <AppBar />

      <Box mb={2} mt={2}>
        <SubjectSelector
          pictureSets={[currentPictureSet]}
          legend={<Trans>New picture set</Trans>}
        />
      </Box>

      <div className={classes.root}>
        <HTMLCarousel>
          {currentPictureSet.pictures.map((picture) => {
            return (
              <HTMLCarouselItem>
                <div
                  className={classes.listItem}
                  style={{
                    backgroundImage: `url(${webshopUserImageUrlCreator(picture.uuid, 320)}`,
                  }}
                />
              </HTMLCarouselItem>
            );
          })}
        </HTMLCarousel>

        <Box m={1}>
          <Button
            component={Link}
            variant="contained"
            color="primary"
            fullWidth
            to="/products/packages"
          >
            <Trans>View offers and campaigns</Trans>
          </Button>
        </Box>
      </div>
    </MobilePage>
  );
};
